/*
 * File: page-template.service.ts                                              *
 * Project: catalog-cloud                                                      *
 * File Created: Thursday, 17th February 2022 11:48:25                         *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Thursday, 2nd March 2023 14:40:19                            *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */

import { Injectable } from '@angular/core';
import { firstValueFrom, Subject } from 'rxjs';
import { PageTemplateFormComponent } from '../components/page/page-template-form/page-template-form.component';
import { PageTemplate } from '@nousmedis/cc-types';
import { ApiService } from '../../api/services/api.service';
import { environment } from "environment";
import { DialogService } from 'primeng/dynamicdialog';
import { PageTemplateListComponent } from '../components/page/page-template-list/page-template-list.component';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class PageTemplateService {
  protected get urlBase(): string { return this.api.getBaseUrl(); }

  get url(): string { return this.urlBase + '/api/v1/page-templates'; }
  templatesModified: Subject<boolean> = new Subject<boolean>();
  constructor (private api: ApiService, private modal: DialogService, private trans: TranslateService) { }

  getTemplates() {
    return this.api.get(this.url + '/');
  }

  getTemplate(id: string) {
    return this.api.get(this.url + '/' + id);
  }

  cloneTemplate(userId: string, id: string) {
    return this.api
      .post(this.url + '/clone', { id: id, idUser: userId })
      .subscribe((data) => {
        this.templatesModified.next(true);
      });
  }

  removeTemplate(id: string) {
    return this.api.delete(this.url + '/' + id).subscribe((data) => {
      this.templatesModified.next(true);
    });
  }

  setTemplate(pageTemplate: PageTemplate) {
    return this.api.post(this.url + '/', pageTemplate);
  }

  updateTemplate(pageTemplate: PageTemplate) {
    return this.api.put(this.url + '/', pageTemplate);
  }


  openTemplateList() {
    return this.modal
      .open(PageTemplateListComponent, {
      }).onClose.subscribe((data) => {
        this.templatesModified.next(true);
      });

  }

  editPageTemplateForm(userId: string, idTemplate: string) {
    
    return this.modal
      .open(PageTemplateFormComponent, {
        data: {
          idTemplate: idTemplate,
          idUser: userId,
        }
      }).onClose.subscribe((data) => {
        this.templatesModified.next(true);
      });;
  }

  newPageTemplateForm(userId: string) {
    return this.modal
      .open(PageTemplateFormComponent, {
        data: {
          idTemplate: '',
          idUser: userId,
        }
      }).onClose.subscribe((data) => {
        this.templatesModified.next(true);
      });

  }

  getBreadCrumbPageTemplateList() {
    return new Promise((resolve, reject) => {
      this.trans.get('PAGE.LIST').subscribe((res) => {
        const breadcrumbs = [
          {
            label: res,
            url: '/catalog-cloud/page-templates',
          },
        ];
        resolve(breadcrumbs);
      });
    });
  }

  async getBreadCrumbPageTemplateEdit(id: string) {
    const [template, listLabel, editLabel] = await Promise.all([
      firstValueFrom(this.getTemplate(id)),
      firstValueFrom(this.trans.get('PAGE.LIST')),
      firstValueFrom(this.trans.get('PAGE.EDIT_TEMPLATE')),
    ]);
    return [
      { label: listLabel, url: '/page-templates/list' },
      { label: template?.name ?? id, url: `/page-templates/${id}` },
      { label: editLabel },
    ];
  }

  getBreadCrumbPageTemplateNew() {
    return new Promise((resolve) => {
      this.trans.get(['PAGE.LIST', 'PAGE.NEW_TEMPLATE']).subscribe((res) => {
        resolve([
          { label: res['PAGE.LIST'], url: '/page-templates/list' },
          { label: res['PAGE.NEW_TEMPLATE'] },
        ]);
      });
    });
  }

  pageTemplateIsInUse(id: string){
    return this.api.get(this.url + '/inuse/' + id);
  }

  exportTemplate(id: string) {
    return this.api.getFile(this.url + '/' + id + '/export');
  }

  importTemplate(template: object, name: string, userId: string) {
    return this.api.post(this.url + '/import', { template, name, userId });
  }
}
